import { DocumentTypeCodeEnum } from '@elearning-platform/api-types/enums';
import { DocumentArchiveAddFileResultInterface } from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const downloadDocumentFromUserArchiveByReviewer: (ownerId: number, documentId: number) => Promise<void> = (
  ownerId: number, documentId: number
): Promise<void> => api.get(
  `/archive-administration/users/${ownerId}/documents/${documentId}/download`, { responseType: 'blob' }
);

export const downloadFileFromUserArchiveByReviewer: (
  ownerId: number, documentId: number, fileId: number
) => Promise<void> = (
  ownerId: number, documentId: number, fileId: number
): Promise<void> => api.get(
  `/archive-administration/users/${ownerId}/documents/${documentId}/files/${fileId}/download`, { responseType: 'blob' }
);

export const downloadFileFromUserArchiveByReviewerAsStream: (
  ownerId: number, documentId: number, fileId: number
) => Promise<string> = (
  ownerId: number, documentId: number, fileId: number
): Promise<string> => api.get(
  `/archive-administration/users/${ownerId}/documents/${documentId}/files/${fileId}/download`,
  { customEnv: { notEncryptedResponse: true } }
);

export const uploadUserDocuments: (
  userId: string, documentTypeCode: DocumentTypeCodeEnum, files: File[]
) => Promise<DocumentArchiveAddFileResultInterface> = (
  userId: string, documentTypeCode: DocumentTypeCodeEnum, files: File[]
): Promise<DocumentArchiveAddFileResultInterface> => {
  const formData: FormData = new FormData();
  formData.append('documentTypeCode', documentTypeCode);
  files.forEach((file: File): void => formData.append('files', file));

  return api.post(
    `archive-administration/users/${userId}/documents`,
    formData,
    { customEnv: { notEncryptedRequest: true } },
  );
};
